import { ProductTypes } from '@editor/config/constants'
import { UserInfo } from '@editor/interfaces/user'

import PCDQuickControls from '../../components/PCDQuickControls'
import { BlueprintEditorTool, BlueprintEditorTools } from '../../definitions'
import BlueprintFormModal from './components/BlueprintFormModal'
import MaskRegionPanel from './components/MaskRegionPanel'
import ViewSwitcher from './components/ViewSwitcher'
import useEditor from './hooks/useEditor'
import useMainCanvas from './hooks/useMainCanvas'

const BlueprintManager: BlueprintEditorTool = {
  key: BlueprintEditorTools.BlueprintManager,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Markly) && isAllowedToModify) || false,
  components: {
    editor: [ViewSwitcher, BlueprintFormModal, PCDQuickControls],
    panel: MaskRegionPanel,
  },
  hooks: {
    useEditor,
    useMainCanvas,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
    dependencies: [BlueprintEditorTools.BlueprintManager],
  },
}

export default BlueprintManager
